import { css } from 'lit';

/*
NOTE: Do not change/add anything here without asking from designer.
Design might accidentally differ from what is predefined, please check incase it occurs.
*/
export const theme = {
  colors: {
    primary: {
      v0: css`#007DC5`,
      v1: css`#005C90`,
      v2: css`#002A4E`,
    },
    text: css`#4D4D4D`,
    shade0: css`#FFFFFF`,
    shade1: css`#FAFAFA`,
    shade2: css`#F1F1F1`,
    shade3: css`#CCCCCC`,
    shade4: css`#666666`,
    shade5: css`#333333`,
    transparent: css`#00000000`,
    warn: css`#DB9316`,
    error: css`#912412`,
    success: css`#007035`,
    available: css`#43D36B`,
    inputError: css`#CC0000`,
    selectedColor: css`#007DC533`,
  },
  shadows: {
    primary: css`0px 0px 6px rgba(0, 0, 0, 0.16)`, // On prototypes: #00000029;
    secondary: css`0px 0px 6px rgba(0, 0, 0, 0.08)`, // On prototypes: #00000014
    top: css`0px -3px 6px rgba(0, 0, 0, 0.04)`,
    bottom: css`0px 3px 6px rgba(0, 0, 0, 0.04)`,
    right: css`3px 0px 6px rgba(0, 0, 0, 0.04)`,
    left: css`-3px 0px 6px rgba(0, 0, 0, 0.04)`,
  },
};
